module.exports = __webpack_public_path__ + "img/parking-d.72bbada3.png";